/**
 * @generated SignedSource<<2cedc8fec9cbda2e294d732d52625e52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type routeCommunityEnabledQuery$variables = {
  slug: string;
};
export type routeCommunityEnabledQuery$data = {
  readonly club: {
    readonly configuration: string | null | undefined;
  };
};
export type routeCommunityEnabledQuery = {
  response: routeCommunityEnabledQuery$data;
  variables: routeCommunityEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COMMUNITY_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeCommunityEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeCommunityEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c1871f9617bb4f405f031c6a51f3978a",
    "id": null,
    "metadata": {},
    "name": "routeCommunityEnabledQuery",
    "operationKind": "query",
    "text": "query routeCommunityEnabledQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    configuration(key: \"COMMUNITY_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7584293842e1ba984420cf98d4ab07eb";

export default node;
